import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ChangeRegionComponent } from 'app/core/change-region/change-region.component';
import { ServiceType } from 'app/core/service-type.model';
import { settings, Settings } from 'app/core/settings';
import { getPolicyData, PolicyData } from 'app/services/policy.service';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { AccountService } from 'app/user/account.service';
import { AuthService } from 'app/user/auth.service';
import { UserSettingsService } from 'app/user/user-settings.service';
import { UserService } from 'app/user/user.service';
import { ButtonTypes } from './../../ui/button/button.component';

@Component({
  selector: 'shell',
  templateUrl: 'shell.component.html',
  styleUrls: ['shell.component.scss']
})
export class ShellComponent {
  get serviceType(): ServiceType {
    return this._userSettingsService.serviceType;
  }

  get userName(): string {
    return this._userService.userName;
  }

  get settings(): Settings {
    return settings;
  }

  get showBackground(): boolean {
    return this._userSettingsService.showBackground;
  }

  linkPrivatePolicy: string;
  linkCookiePolicy: string;

  buttonTypes = ButtonTypes;

  constructor(
    private _authService: AuthService,
    private _accountService: AccountService,
    private _router: Router,
    private _userService: UserService,
    private _userSettingsService: UserSettingsService,
    private dialogService: UIDialogService
  ) {
    const policyData: PolicyData = getPolicyData(
      this._userSettingsService.region
    );
    this.linkPrivatePolicy = policyData.privacyPolicyUrl;
    this.linkCookiePolicy = policyData.cookiePolicyUrl;
    const { url } = this._router;

    if (url.indexOf('documents') !== -1) {
      this._userSettingsService.serviceType = ServiceType.DocumentCapture;
    }
    if (url.indexOf('invoices') !== -1) {
      this._userSettingsService.serviceType = ServiceType.InvoiceCapture;
    }
  }

  hasServiceType(serviceType: string): boolean {
    return this._userSettingsService.serviceType === serviceType;
  }

  logout(): void {
    this._authService
      .logout()
      .subscribe(() => this._router.navigateByUrl('/login'));
  }

  changeRegion() {
    this.dialogService.open(ChangeRegionComponent);
  }
}
